import { render, staticRenderFns } from "./TableHeadActionsBase.vue?vue&type=template&id=4dda8c20"
import script from "./TableHeadActionsBase.vue?vue&type=script&lang=ts"
export * from "./TableHeadActionsBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports